// Theme-aware react-select styles, driven by the CSS custom properties defined
// in index.css (and swapped by the [data-theme="light"] override) — using
// var(...) here means these styles automatically track the active theme
// without needing to read the theme context in every page that uses a select.
export const getSelectStyles = () => ({
  control: (p, s) => ({
    ...p,
    background: 'var(--color-surface-2)',
    borderColor: s.isFocused ? 'var(--color-primary)' : 'var(--color-border)',
    borderRadius: 8,
    boxShadow: s.isFocused ? '0 0 0 3px var(--color-primary-bg)' : 'none',
    minHeight: 42,
    '&:hover': { borderColor: 'var(--color-primary-l)' },
  }),
  menu: (p) => ({
    ...p,
    background: 'var(--color-surface)',
    border: '1px solid var(--color-border)',
    borderRadius: 8,
    zIndex: 20,
  }),
  option: (p, s) => ({
    ...p,
    background: s.isFocused ? 'var(--color-surface-2)' : 'transparent',
    color: s.isFocused ? 'var(--color-text)' : 'var(--color-muted)',
    fontSize: '0.875rem',
  }),
  singleValue: (p) => ({ ...p, color: 'var(--color-text)', fontSize: '0.875rem' }),
  input: (p) => ({ ...p, color: 'var(--color-text)' }),
  placeholder: (p) => ({ ...p, color: 'var(--color-placeholder)', fontSize: '0.875rem' }),
  clearIndicator: (p) => ({ ...p, color: 'var(--color-primary)', '&:hover': { color: 'var(--color-danger)' } }),
  dropdownIndicator: (p) => ({ ...p, color: 'var(--color-primary)' }),
  indicatorSeparator: (p) => ({ ...p, background: 'var(--color-border)' }),
});
